import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BranchInfo } from "../../../model/home/BranchInfoModel";
import { SocialType } from "../../../provider/home/HomeContextProvider";
import { SearchBranchList } from "../../../model/branch/BranchListModel";

interface HomeInterface {
  branchDetail?: BranchInfo | null;
  contactList?: Array<string> | undefined;
  socialLinks?: Array<SocialType> | undefined;
  switchBranchDetail?: SearchBranchList;
}

const initialState: HomeInterface = {
  branchDetail: null,
  contactList: undefined,
  socialLinks: undefined,
  switchBranchDetail: undefined,
};

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setBranchInfo: (state, action: PayloadAction<HomeInterface>) => {
      return { ...state, ...action.payload };
    },
    applyBranchSwitch: (state, action: PayloadAction<HomeInterface>) => {
      state.switchBranchDetail = action.payload.switchBranchDetail;
    },
  },
});

export const { setBranchInfo, applyBranchSwitch } = homeSlice.actions;
export default homeSlice.reducer;
